import { render, staticRenderFns } from "./ticket-multiselect-ajax.vue?vue&type=template&id=7940d946&scoped=true&"
import script from "./ticket-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./ticket-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7940d946",
  null
  
)

export default component.exports